<template>
  <code-block>&lt;vc-parallax nav-color="{{ configurator.navColor.model }}" nav-accent-color="{{ configurator.navAccentColor.model }}" nav-type="{{ configurator.navType.model }}" nav-position="{{ configurator.navPosition.model }}"&gt;
  <template v-for="n in sections">&lt;vc-parallax-section color="{{ configurator.sectionColor.model }}" bg-color="{{ configurator.sectionBgColor.model }}"&gt;
    &lt;p&gt;Section {{ n }} content...&lt;/p&gt;
  &lt;/vc-parallax-section&gt;</template>
&lt;/vc-parallax&gt;</code-block>
</template>
<script>
export default {
  name: 'CodeViewer',
  props: {
    configurator: {
      type: Object,
      required: true
    },
    sections: {
      type: Number,
      required: false,
      default: 3
    }
  }
}
</script>



// WEBPACK FOOTER //
// code-viewer.vue?433e2da2